// src/hooks/useGrammarLogic.js
import { useState, useMemo } from 'react';
import { formatText } from '../utils/textUtils';

export function useGrammarLogic(module) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  // ✅ NORMALIZACIÓN DE TÓPICOS
  // Usamos useMemo para que los tópicos no se recalculen a menos que cambie el módulo
  const topics = useMemo(() => {
    if (!module) return [];

    // Si existen tópicos específicos, los usamos
    if (module.grammarTopics && module.grammarTopics.length > 0) {
      return module.grammarTopics;
    }

    // Si no hay tópicos, creamos un fallback basado en el texto general del módulo
    return [{
      title: "Resumen General",
      content: module.grammarText || "No hay información disponible aún.",
      examples: [],
      tips: []
    }];
  }, [module]);


  return {
    isSidebarOpen,
    setSidebarOpen,
    topics,
    formatText
  };
}